import { datadogRum } from "@datadog/browser-rum";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./assets/fonts/Roboto-Bold.ttf";
import "./assets/fonts/Roboto-Italic.ttf";
import "./assets/fonts/Roboto-Light.ttf";
import "./assets/fonts/Roboto-Medium.ttf";
import "./assets/fonts/Roboto-Regular.ttf";
import "./assets/fonts/RobotoSlab-Bold.ttf";
import "./assets/fonts/RobotoSlab-Regular.ttf";
import WrapperProvider from "./modules/WrapperProvider";
import "./styles/vendors.css";

window.digitalData = {
  push(): void {
    return;
  },
};

if (window.MLBBest.envVariables.ENV !== "local") {
  datadogRum.init({
    applicationId: window.MLBBest.envVariables.DATADOG_APP_ID,
    clientToken: window.MLBBest.envVariables.DATADOG_CLIENT_TOKEN,
    site: "us5.datadoghq.com",
    service: "best---blue-application",
    env: window.MLBBest.envVariables.ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  });

  datadogRum.startSessionReplayRecording();
}

const blueApp = document.getElementById("blue-app");
const root = createRoot(blueApp);
root.render(
  <WrapperProvider>
    <App />
  </WrapperProvider>,
);
